<template>
  <div class="setup-case">
    <Row class="detail-header">
      <span>立案阶段</span>
      <Button
        v-if="infoCtrl && isDetailLoad" type="primary"
        @click="getDetail('edit')"
      >修改</Button>
    </Row>
    <Row class="case-content">
      <Form
        v-if="!infoCtrl && isDetailLoad" ref="formValidate"
        class="case-form" :model="formValidate"
        :rules="ruleValidate" :label-width="100"
      >
        <FormItem label="立案机关" prop="unit">
          <Input v-model="formValidate.unit" placeholder="请输入立案机关" />
        </FormItem>
        <FormItem label="立案日期" prop="reportDate">
          <DatePicker
            transfer type="date"
            placeholder="请选择立案日期" style="width:100%"
            format="yyyy-MM-dd"
            :value="formValidate.reportDate" @on-change="getValue"
          />
        </FormItem>
        <FormItem label="立案通知书" prop="attachmentList">
          <file-upload
            :default-list="defaultList || []" :upload-config="{}"
            @getFileList="getAttachmentList"
          />
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input
            v-model="formValidate.remark" type="textarea"
            placeholder="请输入备注"
          />
        </FormItem>

        <Row class="detail-btn-box">
          <Button
            type="primary" style="margin-right:10px;"
            :disabled="isSubmit"
            @click="submitNew"
          >保存</Button>
          <Button v-if="defaultData" @click="infoCtrl = true">取消</Button>
        </Row>
      </Form>
      <Row v-if="infoCtrl && isDetailLoad" class="detail-content">
        <Row>
          <Col span="5" class="left-label">立案机关：</Col>
          <Col span="16" class="right-content">{{ defaultData.unit || "" }}</Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">立案日期：</Col>
          <Col span="16" class="right-content">{{ defaultData.reportDate || "" }}</Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">立案通知书：</Col>
          <Col span="16" class="right-content">
            <file-upload
              :default-list="defaultData.attachmentList || []"
              :upload-config="{ readOnly: true }"
            />
          </Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">备注：</Col>
          <Col span="16" class="right-content">{{ defaultData.remark || "" }}</Col>
        </Row>
      </Row>
    </Row>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['caseId', 'processId'],
  data() {
    return {
      editId: '',
      isSubmit: false,
      infoCtrl: false,
      isDetailLoad: false,
      defaultData: '',
      defaultList: [],
      timeArr: [],
      formValidate: {
        reportDate: '',
        remark: '',
        unit: '',
        attachmentList: []
      },
      ruleValidate: {
        unit: [{ required: true, message: '立案机关不能为空', trigger: 'blur' }],
        reportDate: [{ required: true, message: '立案日期不能为空', trigger: 'blur' }],
        attachmentList: [{ required: true, type: 'array', message: '立案通知书不能为空', trigger: 'change' }],
        remark: [{ max: 256, message: '不能超过256个字符', trigger: 'blur' }]
      }
    }
  },
  watch: {},
  created() { },
  beforeMount() {
    this.getDetail()
  },
  mounted() { },
  updated() { },
  methods: {
    // 获取受理详情
    getDetail(type) {
      const url = '/business/case/criminal/filing'
      const ajaxData = {
        processId: this.processId
      }
      this.$get(url, ajaxData).then(res => {
        if (res.code == 0 && res.data) {
          this.defaultData = res.data
          this.infoCtrl = type != 'edit'
          if (type == 'edit') {
            this.giveDefaultData(res.data)
          }
          this.isDetailLoad = true
        } else {
          this.defaultData = ''
          this.infoCtrl = false
          this.isDetailLoad = true
        }
      })
    },
    getValue(value) {
      this.formValidate.reportDate = value
    },
    // 获取图片列表
    getAttachmentList(arr) {
      this.formValidate.attachmentList = []
      arr.forEach((item) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formValidate.attachmentList.push(obj)
      })
    },
    submitNew() {
      const url = '/business/case/criminal/filing'
      const ajaxData = {
        processId: this.processId,
        caseId: this.caseId
      }
      Object.assign(ajaxData, this.formValidate)
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          this.isSubmit = true
          if (this.defaultData) {
            ajaxData.id = this.editId
            this.$patch(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          } else {
            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        }
      })
    },
    giveDefaultData(value) {
      const data = JSON.parse(JSON.stringify(value))
      this.editId = data.id
      for (const key in this.formValidate) {
        this.formValidate[key] = data[key]
      }
      this.formValidate.attachmentList = []
      this.defaultList = []
      data.attachmentList.forEach((attItem) => {
        const obj = {
          fileName: attItem.fileName,
          mediaType: attItem.mediaType,
          smallUrl: attItem.smallUrl,
          url: attItem.url
        }
        this.formValidate.attachmentList.push(obj)
        this.defaultList.push(obj)
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../civilCase/caseCommon.scss';
</style>



// WEBPACK FOOTER //
// src/view/criminalCase/filingStage/index.vue